const Navigation = {};
export default Navigation;
//# sourceMappingURL=index.js.map